/**
 * expiration period - select > option に使用するタグ項目
 * @type {{D30: {label: string, value: number}, D90: {label: string, value: number}, INFINITE: {label: string, value: number}, D60: {label: string, value: number}}}
 */
export const PERIODS = {
  D30: {
    label: '30日間',
    value: 30,
  },
  D60: {
    label: '60日間',
    value: 60,
  },
  D90: {
    label: '90日間',
    value: 90,
  },
  INFINITE: {
    label: '再表示しない',
    value: -1,
  },
};

/**
 * expiration period - select > option に使用するタグ項目をリスト化 {@link PERIODS}
 * @type {any[]}
 */
export const PERIODS_ARRAY = Object.values(PERIODS);

/**
 * project version number - `package.json`.version
 * - generate script: script path に使用します
 * @type {string}
 */
export const VERSION_NO = require('../../../../package.json').version;

/**
 * survey script path
 * @type {string}
 */
export const SURVEY_SCRIPT_URL = `https://cdn.rex.contents.rakuten.co.jp/rex-ips/${VERSION_NO}/js/main.js`;

/**
 * enen URL base path
 * - survey ID 末尾に追加し完成です
 * @type {string}
 */
export const ENEN_ADMIN_URL = 'https://enen.intra.rakuten-it.com/admin/show/';

/**
 * manual link - [PoPAsk] Implementation Manual / 実装手順書
 * @type {string}
 */
export const MANUAL_URL =
  'https://confluence.rakuten-it.com/confluence/x/RshCb';

/**
 * generator 作成データを保存する storage name
 * @type {string}
 */
export const LOCAL_STORAGE_NAME = 'survey-config-intermediate';

export default {
  VERSION_NO,
  SURVEY_SCRIPT_URL,
  ENEN_ADMIN_URL,
  MANUAL_URL,
  LOCAL_STORAGE_NAME,
};



// WEBPACK FOOTER //
// ./src/phase2/generator/config/condition.js